import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "btn btn-success btn-form-submit btn-submit-filter",
  type: "submit",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseThoughtFilter"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter anwenden ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Filter verwerfen ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormControlInput = _resolveComponent("FormControlInput")!
  const _component_FormControlSelect = _resolveComponent("FormControlSelect")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Form = _resolveComponent("Form")!
  const _component_WdwDynbox = _resolveComponent("WdwDynbox")!

  return (_openBlock(), _createBlock(_component_WdwDynbox, {
    title: 'Filter',
    minimize: true,
    config: { showControls: true },
    watermark: true,
    ref: "wdwDynboxRef"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_component_Form, {
        onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.useFilter($event))),
        key: _ctx.componentKey
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormControlInput, {
            label: "Textsuche",
            name: "textFilter",
            required: false
          }),
          _createVNode(_component_FormControlSelect, {
            additionalLabelClasses: "wdw-filter-label",
            label: "Sortierung",
            name: "sort",
            public: true,
            options: _ctx.sortOptions,
            reload: _ctx.reloadList,
            defaultvalue: [_ctx.getSortKey() + ''],
            onSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedElem($event, _ctx.sortOptions)))
          }, null, 8, ["options", "reload", "defaultvalue"]),
          _createElementVNode("button", _hoisted_1, [
            _createVNode(_component_font_awesome_icon, { icon: "filter" }),
            _hoisted_2
          ]),
          _hoisted_3,
          _createElementVNode("span", {
            class: "btn btn-danger btn-reset-filter",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#collapseThoughtFilter",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "trash-alt" }),
            _hoisted_4
          ])
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 512))
}